import BackLink from '../../BackLink';
import EditFamiliyMember, { EditFamilyMemberProps } from './EditFamilyMember';
import * as constants from '../../constants';

export default function EditFamiliemedlemPage({
    index,
    isHovedmedlem,
    isBarn,
    formInput,
    setFormInput,
    postalCodesListResource,
}: EditFamilyMemberProps) {
    return (
        <div>
            <BackLink destination={constants.LINK_TO_FAMILY_PAGE} />
            <EditFamiliyMember
                postalCodesListResource={postalCodesListResource}
                index={index}
                isHovedmedlem={isHovedmedlem}
                isBarn={isBarn}
                formInput={formInput}
                setFormInput={setFormInput}
            />
        </div>
    );
}
